import { motion } from "framer-motion";
import { ClipboardCheck, PencilLine, CalendarDays, Users, CalendarClock, RefreshCcw, ArrowUpRight } from "lucide-react";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;

const items = [
  { icon: ClipboardCheck, title: "Checklists prontos", desc: "Ao final de cada capítulo, um checklist para revisar a semana e saber exatamente o próximo passo.", span: "sm:col-span-2", testid: "benefit-card-checklists" },
  { icon: PencilLine, title: "Exercícios práticos", desc: "Leia um capítulo, faça o exercício, avance. Aprendizado que vira ação.", span: "", testid: "benefit-card-exercises" },
  { icon: CalendarDays, title: "Calendário de conteúdo", desc: "Monte seu planejamento semanal sem travar no 'o que postar hoje?'.", span: "", testid: "benefit-card-calendar" },
  { icon: Users, title: "Conquista de clientes", desc: "Como apresentar seus serviços, definir preço e fechar o primeiro contrato.", span: "", testid: "benefit-card-clients" },
  { icon: CalendarClock, title: "Plano de 30 dias", desc: "Um blueprint semana a semana para colocar tudo em prática sem parar no caminho.", span: "sm:col-span-2", testid: "benefit-card-blueprint" },
  { icon: RefreshCcw, title: "Ciclo completo", desc: "Começar, medir, ajustar e repetir — o motor que mantém seu crescimento girando.", span: "sm:col-span-3", testid: "benefit-card-cycle" },
];

const Benefits = () => (
  <section className="relative px-6 py-28 sm:py-36 lg:px-12">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(212,175,55,0.06),transparent_55%)]" />
    <div className="relative mx-auto max-w-7xl">
      <motion.p
        className="font-mono-label text-xs uppercase tracking-[0.3em] text-[#D4AF37]"
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
      >
        O que você leva
      </motion.p>
      <motion.h2
        className="font-serif-display mt-6 max-w-3xl text-3xl font-semibold leading-tight text-white sm:text-4xl lg:text-5xl"
        initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: 0.1 }}
      >
        Tudo o que você precisa,
        <span className="italic text-[#D4AF37]"> em um só guia.</span>
      </motion.h2>

      <div data-testid="benefits-bento-grid" className="mt-20 grid grid-cols-1 gap-5 sm:grid-cols-3">
        {items.map((item, i) => (
          <motion.div
            key={item.testid}
            data-testid={item.testid}
            className={`group relative overflow-hidden rounded-2xl border border-[rgba(255,255,255,0.08)] bg-[#121212] p-9 transition-colors duration-500 hover:border-[rgba(212,175,55,0.4)] ${item.span}`}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            whileHover={{ y: -6 }}
          >
            <div className="pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-[rgba(212,175,55,0.07)] blur-2xl transition-opacity duration-500 group-hover:opacity-100" />
            <item.icon className="h-7 w-7 text-[#D4AF37]" strokeWidth={1.5} />
            <h3 className="font-serif-display mt-6 text-xl font-semibold text-white sm:text-2xl">{item.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#A1A1AA]">{item.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Benefits;
